import {HYPHEN as HYPHEN_VALUE} from '@/utils/constants/globalConstants'

// Common KPI list for SE Metrics
export interface KPIItem {
  name: string
  category: 'Engineering Performance KPIs' | 'Vulnerabilities KPIs' | 'Incidents KPIs' | 'AI Metrics KPIs'
}

export const KPI_LIST: KPIItem[] = [
  {name: 'GT Adoption Rate', category: 'Engineering Performance KPIs'},
  {name: 'Build Success Rate', category: 'Engineering Performance KPIs'},
  {name: 'Deployment Frequency', category: 'Engineering Performance KPIs'},
  {name: 'Automation Test Coverage', category: 'Engineering Performance KPIs'},
  {name: 'Overall Automation Coverage', category: 'Engineering Performance KPIs'},
  {name: 'Unit Test Coverage', category: 'Engineering Performance KPIs'},
  {name: 'App Response Time', category: 'Engineering Performance KPIs'},
  {name: 'Software Reusability', category: 'Engineering Performance KPIs'},
  {name: 'Availability', category: 'Engineering Performance KPIs'},
  {name: 'App Crash Rate', category: 'Engineering Performance KPIs'},
  {name: 'Lead Time To Change', category: 'Engineering Performance KPIs'},
  {name: 'Change Fail Rate', category: 'Engineering Performance KPIs'},
  {name: 'Mean Time To Resolve', category: 'Engineering Performance KPIs'},
  {name: 'Critical Vulnerability Aging 0–15 days', category: 'Vulnerabilities KPIs'},
  {name: 'Critical Vulnerability Aging 16–30 days', category: 'Vulnerabilities KPIs'},
  {name: 'Critical Vulnerability Aging 31–60 days', category: 'Vulnerabilities KPIs'},
  {name: 'Critical Vulnerability Aging >60 days', category: 'Vulnerabilities KPIs'},
  {name: 'High Vulnerability Aging 0–15 days', category: 'Vulnerabilities KPIs'},
  {name: 'High Vulnerability Aging 16–30 days', category: 'Vulnerabilities KPIs'},
  {name: 'High Vulnerability Aging 31–60 days', category: 'Vulnerabilities KPIs'},
  {name: 'High Vulnerability Aging >60 days', category: 'Vulnerabilities KPIs'},
  {name: '1 - Critical', category: 'Vulnerabilities KPIs'},
  // {name: 'Critical – Open >60 days', category: 'Vulnerabilities KPIs'},
  {name: '2 - High', category: 'Vulnerabilities KPIs'},
  // {name: 'High – Open >60 days', category: 'Vulnerabilities KPIs'},
  {name: '3 - Medium', category: 'Vulnerabilities KPIs'},
  {name: '4 - Low', category: 'Vulnerabilities KPIs'},
  {name: '5 - Informational', category: 'Vulnerabilities KPIs'},
  {name: 'Total Vulnerability Aging', category: 'Vulnerabilities KPIs'},
  {name: 'Medium Vulnerability Aging 0–15 days', category: 'Vulnerabilities KPIs'},
  {name: 'Medium Vulnerability Aging 16–30 days', category: 'Vulnerabilities KPIs'},
  {name: 'Medium Vulnerability Aging 31–60 days', category: 'Vulnerabilities KPIs'},
  {name: 'Medium Vulnerability Aging >60 days', category: 'Vulnerabilities KPIs'},
  {name: 'Low Vulnerability Aging 0–15 days', category: 'Vulnerabilities KPIs'},
  {name: 'Low Vulnerability Aging 16–30 days', category: 'Vulnerabilities KPIs'},
  {name: 'Low Vulnerability Aging 31–60 days', category: 'Vulnerabilities KPIs'},
  {name: 'Low Vulnerability Aging >60 days', category: 'Vulnerabilities KPIs'},
  {name: 'Informational Vulnerability Aging 0–15 days', category: 'Vulnerabilities KPIs'},
  {name: 'Informational Vulnerability Aging 16–30 days', category: 'Vulnerabilities KPIs'},
  {name: 'Informational Vulnerability Aging 31–60 days', category: 'Vulnerabilities KPIs'},
  {name: 'Informational Vulnerability Aging >60 days', category: 'Vulnerabilities KPIs'},
  {name: 'Total Incidents (P1 - P3)', category: 'Incidents KPIs'},
  {name: 'Code Fix Incidents (P1 - P3)', category: 'Incidents KPIs'},
  {name: 'Total Incidents (P4 - P5)', category: 'Incidents KPIs'},
  {name: 'Code Fix Incidents (P4 - P5)', category: 'Incidents KPIs'},
  // AI Metrics KPIs. All six fields are accepted by the manual-update API and
  // can be flagged for review individually; Hours Saved / Total Hours default
  // to (SP × hourToStoryPointRatio) when left blank but may be entered directly.
  {name: 'AI Adoption', category: 'AI Metrics KPIs'},
  {name: 'Productivity Gain', category: 'AI Metrics KPIs'},
  {name: 'SP Saved', category: 'AI Metrics KPIs'},
  {name: 'Total Effort', category: 'AI Metrics KPIs'},
  {name: 'Hours Saved', category: 'AI Metrics KPIs'},
  {name: 'Total Hours', category: 'AI Metrics KPIs'},
]
// Power BI embed base URL
export const POWER_BI_EMBED_BASE = 'https://app.powerbi.com/reportEmbed?reportId='
// UI labels
export const SOFTWARE_ENGINEERING_METRICS_LABEL = 'Software Engineering Metrics'
export const EXECUTIVE_DASHBOARD_LABEL = 'Executive Dashboard'
// Feedback URL for SEMetrics dashboard
export const FEEDBACK_URL =
  'https://pepsico.sharepoint.com/:l:/t/CICDMaturityDashboard920/FPOVQ4_qg4ZFm6aLMqFhqv4BN0MduE_CKwZkz5vX0F84qA?nav=OTMxNTk1OGUtYjgxZS00ZjI0LWE5ZTQtZTcwODIwMGQzMTBm'

export const DATA_VALIDATION_PHASE_DATE = 25

// Engineering Performance KPI column definitions
export const ENGINEERING_KPI_COLUMNS = [
  'program',
  'deployFreq',
  'automationCoverage',
  'overallAutomationCoverage',
  'unitCoverage',
  'appResponse',
  'reusability',
  'leadTime',
  'availability',
  'crashRate',
  'changeFailRate',
  'meanTimeToResolve',
  'gtAdoptionRate',
  'buildSuccessRate',
  'validationStatus',
]

// Import common display constants
export {HYPHEN} from '@/utils/constants/globalConstants'

// Metrics-related constants for SEMetrics helpers
export const TIME_UNIT_MS = ' ms'
export const TIME_UNIT_HR = ' hr'
export const TIME_UNIT_HRS = ' hrs'
export const DAY = ' day'
export const DAYS = ' days'
export const PERCENTAGE_SIGN = '%'

// GrowthBook feature flag keys
export const SE_METRICS_DOWNLOAD_MONTHS_FLAG = 'se-metrics-reports-download-no-of-months'
export const SE_METRICS_AGING_COLUMNS_FLAG = 'ado-appsec-flow-visibility'
export const SE_METRICS_REPORT_FILE_PREFIX = 'SE_metrics_monthly_report'

// Data source types
export const MANUAL = 'MANUAL'
export const AUTOMATIC = 'AUTOMATIC'

// UI indicators
export const ASTERIX = '*'
export const SINGLE_QUOTES = ''

// Units

// API response keys
export const KEY_ART_END_USER = 'endUserResponseTime'
export const KEY_ART_OVERALL = 'overallResponseTime'

// Program Titles
export const COMMERCIAL_TITLE = 'Commercial'
export const CONSUMER_TITLE = 'Consumer'
export const SUPPLY_CHAIN_TITLE = 'Supply Chain'
export const DSX_TITLE = 'DSX'
export const IBP_GLOBAL_FUNCTIONS_TITLE = 'IBP & Global Functions'
export const COMMERCIAL_AND_CONSUMER_TITLE = 'Commercial & Consumer'

// Aging message for Commercial & Consumer section
export const VULNERABILITY_DATA_MESSAGE =
  '**Age reflects the time since original identification; it is not reset if a vulnerability is reopened.'
export const AGING_COLUMN_MESSAGE =
  'Aging Column shows the count of vulnerabilities that are in an open State for more than 60 days, measured from the first-identified date; reopening does not reset the age.'

// Aging filter options - maps to API response bucket keys
export const AGING_FILTER_OPTIONS = [
  {id: 'metrics0_15d', label: '0-15 days'},
  {id: 'metrics15_30d', label: '16-30 days'},
  {id: 'metrics30_60d', label: '31-60 days'},
  {id: 'metrics60d', label: '>60 days'},
] as const

export type AgingBucketKey = (typeof AGING_FILTER_OPTIONS)[number]['id']

// Program Groups
export const DASHBOARD_B2B = 'B2B'
export const DASHBOARD_DTC = 'DTC'
export const DASHBOARD_SALES_LEAD = 'SalesLead' // Match Angular exactly
export const DASHBOARD_SALES_HUB = 'SalesHub' // Match Angular exactly
export const DASHBOARD_SALES_PRO = 'SalesPro' // Match Angular exactly

// Labels
export const LABEL_B2B_PROGRAMS = 'B2B Programs'
export const LABEL_DTC_PROGRAMS = 'DTC Programs'
export const LABEL_SALES_LEAD_PLUS = 'SalesLead Plus' // Match Angular exactly
export const LABEL_SALES_HUB_PLUS = 'SalesHub Plus' // Match Angular exactly
export const LABEL_SALES_PRO_PLUS = 'SalesPro Plus' // Match Angular exactly

export const SE_METRICS_PARENT_PROGRAMS_FLAG = 'se-metrics-parent-programs-grouping'

// KPI Titles
export const DEPLOYMENT_FREQUENCY = 'Deployment Frequency'
export const TEST_AUTOMATION_TITLE = 'Test Automation'
export const UNIT_TEST_COVERAGE_TITLE = 'Unit Test Coverage'
export const APP_RESPONSE_TIME_TITLE = 'Application Response Time'
export const REUSABILITY_TITLE = 'Software Reusability'
export const AVAILABILITY_TITLE = 'Availability'
export const LEAD_TIME_TITLE = 'Lead Time To Change'
export const MEAN_TIME_TO_RESOLVE = 'Mean Time To Resolve'

// Validation Status Constants
export const VALIDATION_STATUSES = {
  READY_FOR_VALIDATION: 'Ready for Validation',
  VALIDATED: 'Validated',
  VALIDATED_MANUAL: 'Validated (Manual Data)',
  VALIDATION_PENDING: 'Validation Pending',
  ESCALATED: 'Escalated',
  NOT_VALIDATED: 'Not Validated',
  PENDING_REVIEW: 'Pending Review',
  FLAGGED_FOR_REVIEW: 'Flagged for Review',
  UNDER_ANALYSIS: 'Under Analysis',
} as const

export type ValidationStatus = (typeof VALIDATION_STATUSES)[keyof typeof VALIDATION_STATUSES] | null

// KPI Keys (matching Angular constants)
export const DEPLOYMENT_FREQUENCY_KEY = 'Deployment Frequency<\\>(PER MONTH)'
export const TEST_AUTOMATION_KEY = 'Test Automation<\\>Coverage (%)'
export const UNIT_TEST_COVERAGE_KEY = 'Unit Test<\\>Coverage (%)'
export const APP_RESPONSE_TIME_KEY = 'App Response<\\>Time (Milli seconds)'
export const REUSABILITY_KEY = 'Software<\\>Reusability (%)'
export const LEAD_TIME_TO_CHANGE_KEY = 'Lead Time To <\\>Change (Days)'
export const CHANGE_FAIL_RATE_KEY = 'Change Fail <\\>Rate (%)'
export const KPI_APP_RESPONSE = 'App Response Time (Milli seconds)'
export const CHANGE_FAIL_RATE = 'Change Fail Rate'

// Extra Programs
export const EXTRA_PROGRAMS = ['D2C', 'DX', 'Walmart Luminate']

// Department Constants
export const COMMERCIAL_AND_CONSUMER = 'commercialAndConsumer'
export const SUPPLY_CHAIN = 'supplyChain'
export const DSX = 'dsx'
export const IBP_GLOBAL_FUNCTIONS = 'ibpGlobalFunctions'
export const DSX_PROGRAM = 'DSX'

// Additional constants to add
export const CURRENT_STATUS = 'currentStatus'
export const REPO = 'repo'
export const MANUAL_TEST_SUMMARY = 'Manual Test Summary'
export const NUMBER = 'number'
export const TEST_AUTOMATION_FIELDS = 'testAutomationFields'
export const UNIT_TEST_FIELDS = 'unitTestFields'

// PowerBI Constants
export const TOKEN_REFRESH_BUFFER_SECONDS = 120 // 2 minutes before expiry
export const MIN_REFRESH_DELAY_SECONDS = 0

// KPI Definitions for Details Side Panel
export interface KPIDefinition {
  title: string
  info: string
}

export const KPI_DEFINITIONS: KPIDefinition[] = [
  {
    title: 'GT Adoption Rate',
    info: 'Percentage of YAML-based (multi-stage) pipelines utilizing Global Template patterns out of total pipelines, calculated as (GT Adopted Pipelines / Total Pipelines) × 100.',
  },
  {
    title: 'Build Success Rate',
    info: 'Percentage of succeeded CI_Build stages out of total pipeline runs across all linked deploy pipelines within the selected time period, calculated as (Succeeded Build Stages / Total Build Stages) × 100.',
  },
  {
    title: 'Deployment Frequency',
    info: 'Deployment Frequency counts total successful pipeline runs to configured production branches/environments in the current month.\nDeployment Frequency (per month) = Total number of deployments triggered in the configured production pipelines using the specified branches or tags during the month.',
  },
  {
    title: 'Automation Test Coverage',
    info: 'Automation Test Coverage % = Percentage of ADO Test Cases marked as Automation Candidates (AutomationCandidates = "Yes") that have been automated (AutomationStatus1 = "Automated"), calculated as (Automated Test Cases / Total Automation Candidate Test Cases) × 100, tracked against a configurable baseline. All the test cases which are automated from the starting of the program to the last day of the selected calendar month are cumulatively accounted in this KPI.',
  },
  {
    title: 'Overall Automation Coverage',
    info: 'Percentage of all test cases that have been automated.\nAutomated Test Cases ÷ Total Test Cases.\nCounted cumulatively from program start to the end of the selected month.',
  },
  {
    title: 'Unit Test Coverage',
    info: 'Unit Test Coverage (UTC) is calculated as the percentage of covered lines and branch conditions out of total coverable lines and conditions, derived from the latest SonarQube analysis snapshot within the selected month using the formula: UTC% = (Covered Lines + Covered Conditions) / (Lines to Cover + Conditions to Cover) × 100.',
  },
  {
    title: 'Application Response Time',
    info: 'Application Response Time (in milliseconds) of the application for the selected month, it is fetched from AppDynamics via the Overall Application Performance | Average Response Time (ms) metric.',
  },
  {
    title: 'Reusability',
    info: 'Reusability % measures the proportion of story points tagged as Global/Reusable against total story points across all completed sprints after the configured baseline period, calculated as (Global Story Points / Total Story Points) × 100. User Stories should have "Global" tag against each story that can be reused globally along with story points.',
  },
  {
    title: 'System Availability',
    info: 'Minimum availability percentage across all services for the selected program and month, derived from AppDynamics analytics.',
  },
  {
    title: 'App Crash Rate',
    info: 'Percentage of application sessions that ended in a crash during the selected period.Lower values indicate greater application stability for end users.',
  },
  {
    title: 'Lead Time To Change',
    info: 'Average number of days for a User Story to move from "In Progress" to "Completed (default) /Closed" state within the selected month, based on ADO work item state history. For Features, state transition is from "In Progress" to "Deploying" state.',
  },
  {
    title: 'Change Fail Rate',
    info: 'ChangeFailRate is defined as the percentage of production deployments that have failed and required hot fixes to resolve the failed deployments.\nChangeFailRate % (per month) = Number of deployments from hot fix branch in specified month / (Number of deployments from hot fix branch + Number of deployments from main production branch in specified month).',
  },
  {
    title: 'Mean Time To Resolve',
    info: 'Average time (in hours) to resolve incidents within a month, calculated as AVG (Resolved Date – Created Date) for all ServiceNow incidents filtered by configured service and resolved date within the current month.',
  },
  {
    title: 'Total Incidents (P1–P3)',
    info: 'Total number of resolved high-priority incidents (P1 to P3) reported in the selected month across the program.',
  },
  {
    title: 'Code Fix Incidents (P1–P3)',
    info: 'Number of resolved P1–P3 incidents where the resolution involved code-related changes, identified by the resolution subcode: BUG / CODE FIX DEPLOYED.',
  },
  {
    title: 'Total Incidents (P4–P5)',
    info: 'Total number of resolved lower-priority incidents (P4 and P5) reported in the selected month across the program.',
  },
  {
    title: 'Code Fix Incidents (P4–P5)',
    info: 'Number of resolved P4–P5 incidents that required code changes or bug fixes as part of their resolution (Resolution Sub code: BUG/CODE FIX DEPLOYED).',
  },
  {
    title: 'Critical Vulnerabilities',
    info: "Open Critical severity findings across the program's repositories for the selected month, within the selected aging range. A finding stays counted until it is resolved or closed in ServiceNow.",
  },
  {
    title: 'High Vulnerabilities',
    info: "Open High severity findings across the program's repositories for the selected month, within the selected aging range. A finding stays counted until it is resolved or closed in ServiceNow.",
  },
  {
    title: 'Medium Vulnerabilities',
    info: "Open Medium severity findings across the program's repositories for the selected month, within the selected aging range. A finding stays counted until it is resolved or closed in ServiceNow.",
  },
  {
    title: 'Low Vulnerabilities',
    info: "Open Low severity findings across the program's repositories for the selected month, within the selected aging range. A finding stays counted until it is resolved or closed in ServiceNow.",
  },
  {
    title: 'Informational Vulnerabilities',
    info: "Open Informational severity findings across the program's repositories for the selected month, within the selected aging range. A finding stays counted until it is resolved or closed in ServiceNow.",
  },
  {
    title: 'AI Adoption',
    info: 'Percentage of User Stories and Bugs (excluding Removed) where AI was used in the selected month.',
  },
  {
    title: 'Productivity Gain',
    info: 'Hours Saved as a percentage of Total Hours in the selected month.',
  },
  {
    title: 'SP Saved',
    info: 'Total story points saved by using AI on User Stories and Bugs in the selected month.',
  },
  {
    title: 'Total Effort (SP)',
    info: 'Total story points of all User Stories (excluding Removed) in the selected month.',
  },
  {
    title: 'Hours Saved',
    info: 'Total hours saved by using AI on User Stories and Bugs in the selected month.',
  },
  {
    title: 'Total Hours',
    info: 'Total estimated hours of all User Stories and Bugs (excluding Removed) in the selected month.',
  },
]

// Wiki link for SE Metrics onboarding prerequisites
export const WIKI_LINK =
  'https://dev.azure.com/PepsiCoIT/Global_Data_Project/_wiki/wikis/Global_Data_Project.wiki/58004/SE-Metrics-onboarding-prerequisites'

// Details Side Panel text constants
export const DETAILS_SIDE_PANEL_TEXT = {
  FOR_MORE_DETAILS: 'For more details, please refer to our',
  WIKI_PAGE: 'wiki page',
} as const

// Edit Status Side Panel constants
export const EDIT_STATUS_CONSTANTS = {
  STATUS_OPTIONS: ['Flag for Review', 'Validated'],
  FLAG_FOR_REVIEW: 'Flag for Review' as const,
  VALIDATED: 'Validated' as const,
  UNKNOWN_PROGRAM: 'Unknown Program' as const,
  SUBMITTING_TEXT: 'Submitting...' as const,
  SUBMIT_TEXT: 'Submit' as const,
  CANCEL_TEXT: 'Cancel' as const,
}

// Status constants matching Angular implementation
export const STATUS_CONSTANTS = {
  // Display status strings
  READY_FOR_VALIDATION_STATUS: 'Ready for Validation',
  VALIDATED_STATUS: 'Validated',
  NOT_VALIDATED_STATUS: 'Not Validated',
  VALIDATION_PENDING_STATUS: 'Validation Pending',
  ESCALATED_STATUS: 'Escalated',
  PENDING_REVIEW_STATUS: 'Pending Review',
  FLAG_FOR_REVIEW_STATUS: 'Flag for Review',
  UNDER_ANALYSIS_STATUS: 'Under Analysis',

  // Enum values for API calls
  READY_FOR_VALIDATION: 'READY_FOR_VALIDATION',
  VALIDATED: 'VALIDATED',
  VALIDATED_MANUAL: 'VALIDATED_MANUAL',
  NOT_VALIDATED: 'NOT_VALIDATED',
  VALIDATION_PENDING: 'VALIDATION_PENDING',
  ESCALATED: 'ESCALATED',
  PENDING_REVIEW: 'PENDING_REVIEW',
  UNDER_ANALYSIS: 'UNDER_ANALYSIS',

  // API payload field names
  MESSAGE: 'message',
  ALERT_METRIC_TYPE: 'alertMetricTypes',
} as const

export const EDIT_STATUS_TEXT = {
  UPDATE_STATUS_DESCRIPTION:
    'Update the status of these KPIs - Engineering Performance, Risk & Reliability and AI Metrics',
  PROGRAM_NAME_LABEL: 'Program Name',
  STATUS_LABEL: 'Status',
  ENGINEERING_PERFORMANCE_LABEL: 'Engineering Performance KPIs',
  VULNERABILITIES_LABEL: 'Vulnerabilities KPIs',
  INCIDENT_LABEL: 'Incident KPIs',
  AI_METRICS_LABEL: 'AI Metrics KPIs',
  DESCRIPTION_LABEL: 'Description',
  DESCRIPTION_PLACEHOLDER: 'Type here',
  DESCRIPTION_HELPER_TEXT: 'Please provide a brief description of the issue.',
  NOTE_TEXT: 'Note: Only one issue can be raised per cycle.',
  SUCCESS_MESSAGE: (programName: string) => `Status updated for program '${programName}'`,
  VALIDATED_SYNC_MESSAGE: (programName: string) =>
    `'${programName}' has been validated. The status is now in sync across Engineering Performance KPIs, Risk & Reliability, and AI Metrics sub-tabs.`,
  ERROR_MESSAGE: 'Failed to update status. Please try again.',
} as const

// Helper function to get available status options based on current status
export const getAvailableStatusOptions = (currentStatus: string): string[] => {
  switch (currentStatus) {
    case STATUS_CONSTANTS.READY_FOR_VALIDATION_STATUS:
      return [STATUS_CONSTANTS.VALIDATED_STATUS, STATUS_CONSTANTS.FLAG_FOR_REVIEW_STATUS]
    case STATUS_CONSTANTS.VALIDATED_STATUS:
    case STATUS_CONSTANTS.NOT_VALIDATED_STATUS:
      return [] // No options available - locked
    case STATUS_CONSTANTS.VALIDATION_PENDING_STATUS:
      return [STATUS_CONSTANTS.VALIDATED_STATUS, STATUS_CONSTANTS.FLAG_FOR_REVIEW_STATUS]
    case STATUS_CONSTANTS.ESCALATED_STATUS:
      return [STATUS_CONSTANTS.VALIDATED_STATUS, STATUS_CONSTANTS.FLAG_FOR_REVIEW_STATUS]
    case STATUS_CONSTANTS.PENDING_REVIEW_STATUS:
      return [STATUS_CONSTANTS.UNDER_ANALYSIS_STATUS]
    case STATUS_CONSTANTS.UNDER_ANALYSIS_STATUS:
      return [STATUS_CONSTANTS.VALIDATED_STATUS]
    default:
      return [STATUS_CONSTANTS.VALIDATED_STATUS, STATUS_CONSTANTS.FLAG_FOR_REVIEW_STATUS]
  }
}

// Helper function to convert status string to enum for API calls
export const convertStatusToEnum = (status: string): string => {
  switch (status) {
    case STATUS_CONSTANTS.READY_FOR_VALIDATION_STATUS:
      return STATUS_CONSTANTS.READY_FOR_VALIDATION
    case STATUS_CONSTANTS.VALIDATED_STATUS:
      return STATUS_CONSTANTS.VALIDATED
    case STATUS_CONSTANTS.NOT_VALIDATED_STATUS:
      return STATUS_CONSTANTS.NOT_VALIDATED
    case STATUS_CONSTANTS.VALIDATION_PENDING_STATUS:
      return STATUS_CONSTANTS.VALIDATION_PENDING
    case STATUS_CONSTANTS.ESCALATED_STATUS:
      return STATUS_CONSTANTS.ESCALATED
    case STATUS_CONSTANTS.PENDING_REVIEW_STATUS:
      return STATUS_CONSTANTS.PENDING_REVIEW
    case STATUS_CONSTANTS.UNDER_ANALYSIS_STATUS:
      return STATUS_CONSTANTS.UNDER_ANALYSIS
    default:
      return status
  }
}

// Helper function to convert KPI display names to API enum values (matching Angular)
export const convertKPINameToEnum = (kpiName: string): string => {
  switch (kpiName) {
    case 'Deployment Frequency':
      return 'DEPLOYMENT_FREQUENCY'
    case 'Automation Test Coverage':
    case 'Overall Automation Coverage':
      return 'TEST_AUTOMATION'
    case 'Unit Test Coverage':
      return 'UNIT_TEST_COVERAGE'
    case 'App Response Time':
      return 'APP_RESPONSE_TIME'
    case 'Software Reusability':
      return 'REUSABILITY'
    case 'Availability':
      return 'AVAILABILITY'
    case 'App Crash Rate':
      return 'APP_CRASH_RATE'
    case 'Lead Time To Change':
      return 'LEAD_TIME_TO_CHANGE'
    case 'Change Fail Rate':
      return 'CHANGE_FAIL_RATE'
    case 'Mean Time To Resolve':
      return 'MEAN_TIME_TO_RESOLVE'
    case 'GT Adoption Rate':
      return 'GT_ADOPTION_RATE'
    case 'Build Success Rate':
      return 'BUILD_SUCCESS_RATE'
    case '1 - Critical':
    case '2 - High':
    case '3 - Medium':
    case '4 - Low':
    case 'Total Vulnerability Aging':
    case 'Critical Vulnerability Aging 0–15 days':
    case 'Critical Vulnerability Aging 16–30 days':
    case 'Critical Vulnerability Aging 31–60 days':
    case 'Critical Vulnerability Aging >60 days':
    case 'High Vulnerability Aging 0–15 days':
    case 'High Vulnerability Aging 16–30 days':
    case 'High Vulnerability Aging 31–60 days':
    case 'High Vulnerability Aging >60 days':
    case 'Medium Vulnerability Aging 0–15 days':
    case 'Medium Vulnerability Aging 16–30 days':
    case 'Medium Vulnerability Aging 31–60 days':
    case 'Medium Vulnerability Aging >60 days':
    case 'Low Vulnerability Aging 0–15 days':
    case 'Low Vulnerability Aging 16–30 days':
    case 'Low Vulnerability Aging 31–60 days':
    case 'Low Vulnerability Aging >60 days':
    case '5 - Informational':
    case 'Informational Vulnerability Aging 0–15 days':
    case 'Informational Vulnerability Aging 16–30 days':
    case 'Informational Vulnerability Aging 31–60 days':
    case 'Informational Vulnerability Aging >60 days':
      return 'APPSECFLOW_VULNERABILITY'
    case 'Total Incidents (P1 - P3)':
    case 'Code Fix Incidents (P1 - P3)':
    case 'Total Incidents (P4 - P5)':
    case 'Code Fix Incidents (P4 - P5)':
      return 'INCIDENT_COUNTS'
    // All four AI Metrics checkboxes map to a single backend enum `AI_PRODUCTIVITY`
    // (confirmed by backend team). Each selected checkbox still contributes one
    // entry to `alertMetricTypes`, so selecting all four produces four identical
    // 'AI_PRODUCTIVITY' entries — matching the existing pattern used for
    // INCIDENT_COUNTS and APPSECFLOW_VULNERABILITY.
    case 'AI Adoption':
    case 'Productivity Gain':
    case 'SP Saved':
    case 'Total Effort':
    case 'Hours Saved':
    case 'Total Hours':
      return 'AI_PRODUCTIVITY'
    default:
      return kpiName
  }
}

// KPI Categories for filtering
export const KPI_CATEGORIES = {
  ENGINEERING_PERFORMANCE: 'Engineering Performance KPIs',
  VULNERABILITIES: 'Vulnerabilities KPIs',
  INCIDENTS: 'Incidents KPIs',
  AI_METRICS: 'AI Metrics KPIs',
} as const

// Aging KPI names that should be hidden when feature flag is disabled
const AGING_KPI_NAMES = [
  'Total Vulnerability Aging',
  'Critical Vulnerability Aging 0–15 days',
  'Critical Vulnerability Aging 16–30 days',
  'Critical Vulnerability Aging 31–60 days',
  'Critical Vulnerability Aging >60 days',
  'High Vulnerability Aging 0–15 days',
  'High Vulnerability Aging 16–30 days',
  'High Vulnerability Aging 31–60 days',
  'High Vulnerability Aging >60 days',
  'Medium Vulnerability Aging 0–15 days',
  'Medium Vulnerability Aging 16–30 days',
  'Medium Vulnerability Aging 31–60 days',
  'Medium Vulnerability Aging >60 days',
  'Low Vulnerability Aging 0–15 days',
  'Low Vulnerability Aging 16–30 days',
  'Low Vulnerability Aging 31–60 days',
  'Low Vulnerability Aging >60 days',
  'Informational Vulnerability Aging 0–15 days',
  'Informational Vulnerability Aging 16–30 days',
  'Informational Vulnerability Aging 31–60 days',
  'Informational Vulnerability Aging >60 days',
]

// Helper function to filter KPIs by category
export const filterKPIsByCategory = (category: string, showAgingColumns = true) => {
  return KPI_LIST.filter((kpi: KPIItem) => {
    // Filter by category
    if (kpi.category !== category) return false

    // Skip aging KPIs if feature flag is disabled
    if (!showAgingColumns && AGING_KPI_NAMES.includes(kpi.name)) {
      return false
    }

    return true
  })
}

// A program tracks either System Availability or App Crash Rate, never both (see the SelfOnboarding
// System Health toggle). Only one of the two names should ever be shown/selectable in the KPI lists below.
export const SYSTEM_HEALTH_KPI_NAMES = {
  AVAILABILITY: 'Availability',
  APP_CRASH_RATE: 'App Crash Rate',
} as const

// Mutually-exclusive group backing SYSTEM_HEALTH_KPI_NAMES: a program is only ever configured for
// one member of this group, so the others must be excluded from any KPI selection list. Modeled as
// a group (rather than a hardcoded pairwise check) so it stays correct if more mutually-exclusive
// system-health KPIs are ever added.
export const SYSTEM_HEALTH_KPI_GROUP: string[] = Object.values(SYSTEM_HEALTH_KPI_NAMES)

// Matches the AVAILABILITY_METRIC_PREFERENCE contract used by the SelfOnboarding System Health
// toggle (src/components/SelfOnboarding/ProgramDashboardV2/helpers/constants.ts). 'AVAILIBILITY' is
// an intentional API typo baked into the backend contract.
const AVAILABILITY_METRIC_PREFERENCE_VALUES = {
  APP_CRASH_RATE: 'APP_CRASH_RATE',
  SYSTEM_AVAILABILITY: 'AVAILIBILITY',
} as const

interface SystemHealthMetricSource {
  availability?: string | null
  crashRate?: string | null
  automatic?: {AVAILABILITY?: number | null; APP_CRASH_RATE?: number | null} | null
  manual?: {AVAILABILITY?: number | null; APP_CRASH_RATE?: number | null} | null
  // Authoritative source (from the /productDashboards/all-info API's appDynamicsProject block).
  // When present, this takes precedence over the value-presence heuristic below.
  appDynamicsProject?: {availibilityMetricPreference?: string | null} | null
  // Allows loosely-typed callers (e.g. Redux SelectedProgram, raw program list entries) to be
  // passed directly without a type assertion.
  [key: string]: any
}

// Determine which system-health KPI (Availability or App Crash Rate) applies to a given program.
// Prefers the explicit appDynamicsProject.availibilityMetricPreference field (authoritative, set at
// onboarding time) when available. Falls back to a value-presence heuristic for callers/data that
// don't yet carry that field: the backend only returns/populates a value for whichever metric is
// configured for that program, leaving the other one absent (or HYPHEN once processed). Accepts
// either an already-processed metrics row (availability/crashRate strings, e.g. from the SE Metrics
// table) or a raw bulk API response (automatic/manual), so EditStatusSidePanel and UpdateKPISidePanel
// can share it. Falls back to Availability when nothing indicates otherwise, matching legacy behavior.
export const getActiveSystemHealthKpiName = (source?: SystemHealthMetricSource | null): string => {
  if (!source) return SYSTEM_HEALTH_KPI_NAMES.AVAILABILITY

  const preference = source.appDynamicsProject?.availibilityMetricPreference
  if (preference === AVAILABILITY_METRIC_PREFERENCE_VALUES.APP_CRASH_RATE) {
    return SYSTEM_HEALTH_KPI_NAMES.APP_CRASH_RATE
  }
  if (preference === AVAILABILITY_METRIC_PREFERENCE_VALUES.SYSTEM_AVAILABILITY) {
    return SYSTEM_HEALTH_KPI_NAMES.AVAILABILITY
  }

  const hasCrashRate =
    (source.crashRate != null && source.crashRate !== HYPHEN_VALUE) ||
    source.automatic?.APP_CRASH_RATE != null ||
    source.manual?.APP_CRASH_RATE != null

  const hasAvailability =
    (source.availability != null && source.availability !== HYPHEN_VALUE) ||
    source.automatic?.AVAILABILITY != null ||
    source.manual?.AVAILABILITY != null

  return hasCrashRate && !hasAvailability
    ? SYSTEM_HEALTH_KPI_NAMES.APP_CRASH_RATE
    : SYSTEM_HEALTH_KPI_NAMES.AVAILABILITY
}

// Update KPI Side Panel constants
export const UPDATE_KPI_CONSTANTS = {
  DEPLOYMENT_FREQUENCY: 'Deployment Frequency',
  CHANGE_FAIL_RATE: 'Change Fail Rate',
  AUTOMATION_TEST_COVERAGE: 'Automation Test Coverage',
  OVERALL_AUTOMATION_COVERAGE: 'Overall Automation Coverage',
  UNIT_TEST_COVERAGE: 'Unit Test Coverage',
  APP_RESPONSE_TIME: 'App Response Time',
  SOFTWARE_REUSABILITY: 'Software Reusability',
  AVAILABILITY: 'Availability',
  APP_CRASH_RATE: 'App Crash Rate',
  LEAD_TIME_TO_CHANGE: 'Lead Time To Change',
  MEAN_TIME_TO_RESOLVE: 'Mean Time To Resolve',
  GT_ADOPTION_RATE: 'GT Adoption Rate',
  BUILD_SUCCESS_RATE: 'Build Success Rate',
  CRITICAL: '1 - Critical',
  HIGH: '2 - High',
  MEDIUM: '3 - Medium',
  LOW: '4 - Low',
  TOTAL_AGING: 'Total Vulnerability Aging',
  CRITICAL_AGING_0_15D: 'Critical Vulnerability Aging 0–15 days',
  CRITICAL_AGING_16_30D: 'Critical Vulnerability Aging 16–30 days',
  CRITICAL_AGING_31_60D: 'Critical Vulnerability Aging 31–60 days',
  CRITICAL_AGING_GT_60D: 'Critical Vulnerability Aging >60 days',
  HIGH_AGING_0_15D: 'High Vulnerability Aging 0–15 days',
  HIGH_AGING_16_30D: 'High Vulnerability Aging 16–30 days',
  HIGH_AGING_31_60D: 'High Vulnerability Aging 31–60 days',
  HIGH_AGING_GT_60D: 'High Vulnerability Aging >60 days',
  MEDIUM_AGING_0_15D: 'Medium Vulnerability Aging 0–15 days',
  MEDIUM_AGING_16_30D: 'Medium Vulnerability Aging 16–30 days',
  MEDIUM_AGING_31_60D: 'Medium Vulnerability Aging 31–60 days',
  MEDIUM_AGING_GT_60D: 'Medium Vulnerability Aging >60 days',
  LOW_AGING_0_15D: 'Low Vulnerability Aging 0–15 days',
  LOW_AGING_16_30D: 'Low Vulnerability Aging 16–30 days',
  LOW_AGING_31_60D: 'Low Vulnerability Aging 31–60 days',
  LOW_AGING_GT_60D: 'Low Vulnerability Aging >60 days',
  INFORMATIONAL: '5 - Informational',
  INFORMATIONAL_AGING_0_15D: 'Informational Vulnerability Aging 0–15 days',
  INFORMATIONAL_AGING_16_30D: 'Informational Vulnerability Aging 16–30 days',
  INFORMATIONAL_AGING_31_60D: 'Informational Vulnerability Aging 31–60 days',
  INFORMATIONAL_AGING_GT_60D: 'Informational Vulnerability Aging >60 days',
  CODE_FIX_INCIDENTS_P1P3: 'Code Fix Incidents (P1 - P3)',
  TOTAL_INCIDENTS_P1P3: 'Total Incidents (P1 - P3)',
  CODE_FIX_INCIDENTS_P4P5: 'Code Fix Incidents (P4 - P5)',
  TOTAL_INCIDENTS_P4P5: 'Total Incidents (P4 - P5)',
  // AI Metrics manual-update fields
  AI_ADOPTION: 'AI Adoption',
  PRODUCTIVITY_GAIN: 'Productivity Gain',
  SP_SAVED: 'SP Saved',
  TOTAL_EFFORT: 'Total Effort',
  HOURS_SAVED: 'Hours Saved',
  TOTAL_HOURS: 'Total Hours',
} as const

export const UPDATE_KPI_TEXT = {
  REQUIRED_INFO: 'Please provide the required information',
  PROGRAM_NAME_LABEL: 'Program name',
  MONTH_YEAR_LABEL: 'Month & Year',
  KPIS_LABEL: 'KPIs',
  SELECT_PROGRAM: 'Select Program',
  SELECT_MONTH_YEAR: 'Select Month & Year',
  SELECT_KPIS: 'Select KPIs',
  REASON_LABEL: 'Reason',
  REASON_PLACEHOLDER: 'Type here',
  REASON_HELPER: 'Provide a reason to update the KPIs manually.',
  ETA_LABEL: 'ETA',
  ETA_PLACEHOLDER: 'Select date',
  ETA_HELPER: 'Mention estimation of fixing this manual updating KPIs issue.',
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',
  SUCCESS_MESSAGE: (programName: string) =>
    `The KPI data for the program '${programName}' has been successfully updated.`,
  ERROR_MESSAGE: 'Failed to update KPI data. Please try again.',
  PROD_DEPLOYMENT_LABEL: 'Prod Deployment (via mainline/production branch)',
  HOTFIX_DEPLOYMENT_LABEL: 'Hotfix Deployment (via hotfix branch)',
  AUTOMATED_TEST_CASES_LABEL: 'Automated Test Cases',
  TOTAL_TEST_CASES_LABEL: 'Total Test Cases',
  AUTOMATION_CANDIDATE_TEST_CASES_LABEL: 'Automation Candidate Test Cases',
  AUTOMATION_OVERALL_HEADER: 'Automation Test Coverage & Overall Test Coverage',
  GLOBAL_STORY_POINTS_LABEL: 'Global Story Points',
  TOTAL_STORY_POINTS_LABEL: 'Total Story Points',
  DEPLOYMENT_FREQUENCY_HEADER: 'Deployment Frequency & Change Fail Rate',
  ENGINEERING_PERFORMANCE_HEADER: 'Engineering Performance KPIs',
  VULNERABILITIES_HEADER: 'Vulnerabilities KPIs',
  INCIDENTS_HEADER: 'Incidents KPIs',
  ENGINEERING_PERFORMANCE_LABEL: 'Engineering Performance',
  VULNERABILITIES_LABEL: 'Vulnerabilities',
  INCIDENTS_LABEL: 'Incidents',
  AI_METRICS_LABEL: 'AI Metrics',
} as const

// KPI Data mapping constants
export const KPI_DATA_KEYS = {
  DF_AND_CFR: 'DF_AND_CFR',
  TEST_AUTOMATION: 'TEST_AUTOMATION',
  UNIT_TEST_COVERAGE: 'UNIT_TEST_COVERAGE',
  APP_RESPONSE_TIME: 'APP_RESPONSE_TIME',
  AVAILABILITY: 'AVAILABILITY',
  APP_CRASH_RATE: 'APP_CRASH_RATE',
  LEAD_TIME_TO_CHANGE: 'LEAD_TIME_TO_CHANGE',
  MEAN_TIME_TO_RESOLVE: 'MEAN_TIME_TO_RESOLVE',
  INCIDENT_COUNTS: 'INCIDENT_COUNTS',
  REUSABILITY: 'REUSABILITY',
  APPSECFLOW_VULNERABILITY: 'APPSECFLOW_VULNERABILITY',
  GT_ADOPTION_RATE: 'GT_ADOPTION_RATE',
  BUILD_SUCCESS_RATE: 'BUILD_SUCCESS_RATE',
  AI_PRODUCTIVITY: 'AI_PRODUCTIVITY',
} as const

// Form field suffixes
export const FIELD_SUFFIXES = {
  PROD: '_prod',
  HOTFIX: '_hotfix',
  AUTO: '_auto',
  TOTAL: '_total',
  GLOBAL: '_global',
  OVERALL: '_overall',
} as const

// Placeholder text constants
export const PLACEHOLDER_TEXT = {
  DEFAULT: 'E.g 50',
  DEPLOYMENT: 'E.g 15',
  HOTFIX: 'E.g 10',
  TEST_CASES: 'E.g 25',
  TOTAL_TEST_CASES: 'E.g 32',
  AUTOMATION_CANDIDATE_TEST_CASES: 'E.g 32',
  STORY_POINTS: 'E.g 15',
  TOTAL_STORY_POINTS: 'E.g 20',
} as const

// Units for KPI labels
export const KPI_UNITS = {
  UNIT_TEST_COVERAGE: ' (%)',
  APP_RESPONSE_TIME: ' (ms)',
  AVAILABILITY: ' (%)',
  APP_CRASH_RATE: ' (%)',
  LEAD_TIME_TO_CHANGE: ' (days)',
  MEAN_TIME_TO_RESOLVE: ' (hrs)',
  GT_ADOPTION_RATE: ' (%)',
  BUILD_SUCCESS_RATE: ' (%)',
  AI_ADOPTION: ' (%)',
  PRODUCTIVITY_GAIN: ' (%)',
  SP_SAVED: ' (SP)',
  TOTAL_EFFORT: ' (SP)',
  HOURS_SAVED: ' (hrs)',
  TOTAL_HOURS: ' (hrs)',
} as const

// Validation Modal constants
export const VALIDATION_MODAL = {
  TITLE: 'Do you want to confirm validation?',
  TEXT: "Clicking 'Confirm' will validate the 'Engineering Performance KPIs', 'Risk & Reliability' and 'AI Metrics' tabs. Please ensure accuracy, as no edits will be allowed after submission.",
  CONFIRM_BUTTON: 'Confirm',
  CLOSE_BUTTON: 'Close',
} as const
